/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BerechnungsParameterWert
 */
export interface BerechnungsParameterWert {
    /**
     * 
     * @type {number}
     * @memberof BerechnungsParameterWert
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BerechnungsParameterWert
     */
    wert: number;
}

/**
 * Check if a given object implements the BerechnungsParameterWert interface.
 */
export function instanceOfBerechnungsParameterWert(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "wert" in value;

    return isInstance;
}

export function BerechnungsParameterWertFromJSON(json: any): BerechnungsParameterWert {
    return BerechnungsParameterWertFromJSONTyped(json, false);
}

export function BerechnungsParameterWertFromJSONTyped(json: any, ignoreDiscriminator: boolean): BerechnungsParameterWert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'wert': json['wert'],
    };
}

export function BerechnungsParameterWertToJSON(value?: BerechnungsParameterWert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'wert': value.wert,
    };
}

